import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import * as Models from '../dynamic-grid-by-data/dynamic-grid.interface';

@Component({
    selector: 'ui-pagination-new',
    templateUrl: './pagination-new.component.html',
    styleUrls: ['./pagination-new.component.less']
})
export class PaginationNewComponent {

    constructor(
        private viewportScroller: ViewportScroller
    ) { }

    @Input() pagingInfo: Models.PagingInfo;
    @Input() showPaginationListOnTop = false;
    @Input() pageSizesList: Array<number> = Models.GridConfig.pageSizes.map(option => option.value);
    @Output() applyPaging = new EventEmitter<Models.PagingInfo>();

    private emitChanges(): void {
        setTimeout(() => this.applyPaging.emit(this.pagingInfo));
    }

    pageChanged(): void {
        this.emitChanges();

        // Url is not changed, so scroll page to top manually
        this.viewportScroller.scrollToPosition([0, 0]);
    }

    onPageSizeSelect(pageSize: number): void {
        this.pagingInfo.pageSize = pageSize;
        setTimeout(() => this.pagingInfo.pageIndex = 1);
        this.emitChanges();
    }

    get renderedCount(): number {
        const renderedCount: number = this.pagingInfo.pageSize * this.pagingInfo.pageIndex;
        return renderedCount > this.pagingInfo.totalItems ? this.pagingInfo.totalItems : renderedCount;
    }

}
